import React from "react";
import { Header } from "../../../components/Header";
import "./styles.less";
import { CustomerDetailBanner } from "../../../blocks/heigh-educate-banner";
import { useTranslation } from "react-i18next";
import { CommonPageLink } from "../../../blocks/common-page-link";
import { CustomerDetailIntro } from "../../../blocks/customer-detail-intro";
import { Footer } from "../../../components/FooterV2";
import { CustomerDetailChallenge } from "../../../blocks/customer-detail-challenge";
import { CustomerDetailIdea } from "../../../blocks/customer-detail-idea";
import { HomeTryOn } from "../../../blocks/home-try-on";
import { Helmet } from "react-helmet";

export const UniCreditPage = () => {
  const { t } = useTranslation();
  const pagesLink = [
    {
      title: t("common.pageLink.comp.title"),
      description: t("common.pageLink.comp.description"),
      imgurl: "/page-link-comp.png",
      jumpLink: "/learn/guard",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-comp.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-comp.svg",
    },
    {
      title: t("common.pageLink.mfa.title"),
      description: t("common.pageLink.mfa.description"),
      imgurl: "/page-link-mfa.png",
      jumpLink: "/mfa",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-mfa.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-mfa.svg",
    },
    {
      title: t("common.pageLink.verify.title"),
      description: t("common.pageLink.verify.description"),
      imgurl: "/page-link-verify.png",
      jumpLink: "/verify",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-verify.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-verify.svg",
    },
    {
      title: t("common.pageLink.database.title"),
      description: t("common.pageLink.database.description"),
      imgurl: "/page-link-database-connection.png",
      jumpLink: "/database-connection",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-database.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-database.svg",
    },
  ];
  const challenges = [
    {
      title: t("customer.unicredit.challenge.item1.title"),
      description: t("customer.unicredit.challenge.item1.description"),
    },
    {
      title: t("customer.unicredit.challenge.item2.title"),
      description: t("customer.unicredit.challenge.item2.description"),
    },
    {
      title: t("customer.unicredit.challenge.item3.title"),
      description: t("customer.unicredit.challenge.item3.description"),
    },
  ];
  const ideas = [
    {
      title: t("customer.unicredit.ideas.item1.title"),
      descript: t("customer.unicredit.ideas.item1.subtitle"),
      icon: "authing-like",
    },
    {
      title: t("customer.unicredit.ideas.item2.title"),
      descript: t("customer.unicredit.ideas.item2.subtitle"),
      icon: "authing-insurance",
    },
    {
      title: t("customer.unicredit.ideas.item3.title"),
      descript: t("customer.unicredit.ideas.item3.subtitle"),
      icon: "authing-idcard",
    },
  ];
  return (
    <div className="unicredit-page">
      <Helmet>
        <title>
          银行多因素认证与统一身份认证系统，使用API/SDK即可快速部署｜裕信银行 x
          Authing
        </title>
      </Helmet>
      <Header mode="dark" defaltNav={true} />
      <CustomerDetailBanner
        title={t("customer.unicredit.banner.title")}
        addtionTitle={t("customer.unicredit.banner.addtionTitle")}
        subtitle={t("customer.unicredit.banner.subtitle")}
        theme="#007A91"
        imgUrl={
          "//files.authing.co/authing-website/customer-unicredit-banner.png"
        }
      />
      <CustomerDetailIntro
        imgUrl="//files.authing.co/authing-website/customer-unicredit-intro.png"
        alt="企业服务单点登录"
        content={
          <>
            <p>{t("customer.unicredit.intro.descript1")}</p>
            <p>{t("customer.unicredit.intro.descript2")}</p>
          </>
        }
      />
      <CustomerDetailChallenge challenges={challenges} theme={"#007A91"} />
      <CustomerDetailIdea ideas={ideas} theme={"#007A91"} />
      <CommonPageLink pagesLink={pagesLink} theme={"#007A91"} />
      {/* <CustomerConsult /> */}
      <HomeTryOn hasBg />

      <Footer />
    </div>
  );
};
